import React from 'react'
import SurveyList from '~/pages/Survey';

interface Routes {
  path: string;
  title?: string;
  element: any;
  name: string;
  exact?: boolean;
}

export const routes: Routes[] = [
  {
    path: '/',
    title: 'サーベイ',
    element: <SurveyList />,
    name: 'home',
  },
  {
    title: 'サーベイ',
    path: '/survey',
    element: <SurveyList />,
    name: 'survey',
  },
  {
    title: 'サーベイ',
    path: '/survey/:id',
    element: <SurveyList />,
    name: 'surveyDetail',
  },
];
